/**
 *
 * @param value input value can be a string or a number
 * @param decimals amount of decimals (optional)
 * @returns a string value with a formatted as percent (e.g.: 2.50%)
 */
export const formatPercent = (
  value: string | number | null | undefined,
  decimals?: number
) => {
  if (value === null || value === undefined) {
    return null
  } else {
    if (typeof value === 'string') {
      return `${parseFloat(value).toFixed(decimals || 2)}%`
    } else {
      return `${value.toFixed(decimals || 2)}%`
    }
  }
}
